import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/components/dashboard"; // Import the Dashboard component
// Update route path to match new location
export const Route = createFileRoute("/_app/$tenantId/")({
	component: IndexComponent,
});

function IndexComponent() {
	return <Dashboard />;
}
